<template>
  <div class="checkout">
    new address
    <span>上海</span>
    <select v-model='district'>
      <option value='putuo'>普陀</option>
      <option value='jinan'>静安</option>
    </select>
    <input type='text' placeholder='街道门牌号' v-model='street'>
    <p @click='saveAddress()'>保存</p>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'hello',
  data() {
    return {
      district:'',
      street:'',
      msg: 'Welcome to Your Vue.js App',
    };
  },

   computed: {
    ...mapGetters({
       config: 'config',
    }),
  },

  methods: {
    saveAddress() {
      let token = localStorage.getItem('roupooToken');

      this.$http.post(this.config.host + '/admin/api/v1/addresses.json', {street:this.district + this.street})
      .then((data)=>{
           this.$router.push('/address');
      });
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// NewAddress.vue?411a037e